// Kontrola aktivity v iframe betbuildera
betbuilder = {
    checkBBIframeFocus() {
        if(document.activeElement == document.getElementById("betbuilder-iframe")) {
            main.userAction();
            setTimeout(function() {
                window.focus();
            }, 500);
        }
    }
};
